export interface CustomizerSidebar {
  type: string;
  body_type: string;
}

export interface CustomizerSettings {
  layout_type: string;
  sidebar: CustomizerSidebar;
  sidebar_setting: string;
  sidebar_background_setting: string;
}

export interface CustomizerColor {
  layout_version: string;
  color: string;
  primary_color: string;
  secondary_color: string;
  mix_background_layout: string;
}

export interface CustomizerDatabase {
  settings: CustomizerSettings;
  color: CustomizerColor;
  router_animation: string;
}

export class ConfigDB {
  static data: CustomizerDatabase = {
    settings: {
      layout_type: "ltr",
      sidebar: {
        type: "compact-wrapper",
        body_type: "sidebar-icon",
      },
      sidebar_setting: "default-sidebar",
      sidebar_background_setting: "",
    },
    color: {
      layout_version: "light",
      color: "color-1",
      primary_color: "#7366ff",
      secondary_color: "#f73164",
      mix_background_layout: "light-only",
    },
    router_animation: "fade",
  };
}
export default ConfigDB;
